<div class="pick-list">
  <div class="pick-list__wrapper">
    <div class="pick-list__column">
      <div class="pick-list__header">
        <h3 class="pick-list__title">{{ settings?.sourceLabel }}</h3>
        <span class="pick-list__counter">
          <span class="badge badge-primary badge-pill">
            {{ sourceItems.length }}
          </span>
        </span>
      </div>
      <div class="pick-list__container">
        <div class="pick-list__search">
          <input
            type="text"
            class="pick-list__search__input"
            placeholder="Pesquisar..."
            [(ngModel)]="sourceSearchTerm"
            [disabled]="settings?.isDisabled"
          />
          <button
            type="button"
            class="pick-list__clear-btn"
            *ngIf="sourceSearchTerm"
            (click)="clearSourceSearch()"
            [disabled]="settings?.isDisabled"
            title="Limpar pesquisa"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <ul class="pick-list__list">
          <li
            *ngFor="let item of sourceItems; let i = index; trackBy: trackBySourceItem"
            class="pick-list__item"
            [class.pick-list__item--selected]="isSourceItemSelected(i)"
            [title]="item.label"
            (click)="toggleSourceSelection(i)"
            (dblclick)="moveSourceItemToTarget(i)"
          >
            <span class="pick-list__item-label">{{ item?.label }}</span>
            <small *ngIf="item?.text">{{ item.text }}</small>
          </li>
        </ul>
        <div class="pick-list__no-items" *ngIf="sourceSearchTerm && sourceItems.length === 0">
          <span class="pick-list__no-items-text">{{ settings?.emptyResultMessage }}</span>
        </div>
      </div>
    </div>

    <div class="pick-list__controls">
      <button
        type="button"
        class="pick-list__btn"
        [disabled]="!hasSelectedSourceItems() || settings?.isDisabled"
        (click)="moveToTarget()"
        title="Mover selecionados para o destino"
      >
        <span class="pick-list__btn-icon">
          <i class="fas fa-angle-right"></i>
        </span>
      </button>

      <button
        type="button"
        class="pick-list__btn"
        [disabled]="sourceItems.length === 0 || settings?.isDisabled"
        (click)="moveAllToTarget()"
        title="Mover todos para o destino"
      >
        <span class="pick-list__btn-icon">
          <i class="fas fa-angle-double-right"></i>
        </span>
      </button>

      <button
        type="button"
        class="pick-list__btn"
        [disabled]="selectedItems.length === 0 || settings?.isDisabled"
        (click)="moveAllToSource()"
        title="Mover todos para a origem"
      >
        <span class="pick-list__btn-icon">
          <i class="fas fa-angle-double-left"></i>
        </span>
      </button>

      <button
        type="button"
        class="pick-list__btn"
        [disabled]="!hasSelectedTargetItems() || settings.isDisabled"
        (click)="moveToSource()"
        title="Mover selecionados para a origem"
      >
        <span class="pick-list__btn-icon">
          <i class="fas fa-angle-left"></i>
        </span>
      </button>
    </div>

    <div class="pick-list__column">
      <div class="pick-list__header">
        <h3 class="pick-list__title">{{ settings?.targetLabel }}</h3>
        <span class="pick-list__counter">
          <span class="badge badge-primary badge-pill">{{ selectedItems.length }}</span>
        </span>
      </div>
      <div class="pick-list__container">
        <div class="pick-list__search">
          <input
            type="text"
            class="pick-list__search__input"
            placeholder="Pesquisar..."
            [(ngModel)]="targetSearchTerm"
            [disabled]="settings?.isDisabled"
          />

          <button
            type="button"
            class="pick-list__clear-btn"
            *ngIf="targetSearchTerm"
            (click)="clearTargetSearch()"
            [disabled]="settings?.isDisabled"
            title="Limpar pesquisa"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
        <ul class="pick-list__list">
          <li
            *ngFor="let item of selectedItems; let i = index; trackBy: trackByTargetItem"
            class="pick-list__item"
            [class.pick-list__item--selected]="isTargetItemSelected(i)"
            (click)="toggleTargetSelection(i)"
            (dblclick)="moveTargetItemToSource(i)"
            [title]="item.label"
          >
            <span class="pick-list__item-label">{{ item?.label }}</span>
            <small *ngIf="item?.text">{{ item.text }}</small>
          </li>
        </ul>
        <div class="pick-list__no-items" *ngIf="targetSearchTerm && selectedItems.length === 0">
          <span class="pick-list__no-items-text">{{ settings?.emptyResultMessage }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
